/* global AFRAME */

/**
 * Component that listens to an event, fades out an entity, swaps the texture, and fades it
 * back in.
 */

  var timer = 0;
  var lastUpdate = Date.now();
  
 
 
AFRAME.registerComponent('swap-image', {
  schema: {
	offset: {type: 'number', default: 0},
	interval: {type: 'number', default: 1},
	imgstate: {type: 'number', default: 0}
  },
  
  

  tick: function () {
	
	var targetimageurl;
	var now = Date.now();
	var dt = now - global_webvr_adidas.lastUpdate;
	global_webvr_adidas.lastUpdate = now;
	global_webvr_adidas.timer += (dt / 5000);
	var data = this.data
	var x;
	
	if(Math.sin((global_webvr_adidas.timer + data.offset) * data.interval) > 0){
		targetimageurl = '#imageGraphic01';
		x = 0;
	}else{
		targetimageurl = '#imageGraphic01down';
		x=1;
	}
	
	
	if(data.imgstate != x){
		data.imgstate = x;
		this.el.children[0].setAttribute('material', 'src', targetimageurl );
	}
  }
});
